import { render, staticRenderFns } from "./FamilyInfo2.vue?vue&type=template&id=58d57340&scoped=true&"
import script from "./FamilyInfo2.vue?vue&type=script&lang=js&"
export * from "./FamilyInfo2.vue?vue&type=script&lang=js&"
import style0 from "./FamilyInfo2.vue?vue&type=style&index=0&id=58d57340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d57340",
  null
  
)

export default component.exports